export const iconFontAwesomeSecurityEyeSlash = (
	<i className="fa-solid fa-eye-slash"></i>
);
